import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonClose: {
    id: 'app.components.Modal.buttonClose',
    defaultMessage: 'Close',
  },
});
